



import Axios from 'axios';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { UserRegistParam } from 'src_server/param/UserRegistParam';
import { Response } from '../../../src_server/response/Response';
import { UserAuthDTO } from '../../../src_server/entity/dto/UserAuthDTO';

import { URIs } from '../../../src_server/common/URIs';
import { Session } from '../../utils/Session';
import { ErrorHandler } from '../../utils/ErrorHandler';
import { MessageDialog } from '../../utils/MessageDialog';
import { routeHelper } from '../../utils/routeHelper';

@Component
export default class StudentRegisterButton extends Vue {
  @Prop()
  mail!: string;

  @Prop()
  password!: string;

  @Prop()
  building!: string;

  async register() {
    const param: UserRegistParam = {
      mail: this.mail,
      password: this.password,
      type: 'stu',
      building: this.building,
    };

    console.log('register', param);

    const response = await Axios.post<Response<UserAuthDTO>>(URIs.USERS_REGIST.path, param);

    // エラーが発生した場合
    if (response.data.hasError) {
      ErrorHandler.atResponseError(response.data);
      return;
    }

    // 登録が正常終了した場合
    await MessageDialog.alert('登録しました');
    Session.set<UserAuthDTO>('USER', response.data.data);
    routeHelper(this, 'StudentInfoInputMain');
  }
}
